<template>
  <div class="layout-wrapper">
    <!-- Sidebar -->
    <SidebarMenu
      :collapsed="collapsed"
      @update:collapsed="updateCollapsed($event)"
    />

    <!-- Main Content -->
    <div
      class="layout-content"
      :class="{ collapsed }"
      :style="contentStyle"
    >
      <HeaderTopBar v-if="showHeaderTopBar" :userFullName="userFullName" />

      <div class="content flex-grow-1 p-md-3 p-0" >
        <slot />
      </div>

      <Footer />

      <AiAssistantWidget v-if="showAiAssistant" />
    </div>
  </div>
</template>

<script>
import SidebarMenu from "@/components/layout/SidebarMenu.vue";
import HeaderTopBar from "@/components/layout/HeaderTopBar.vue";
import Footer from "@/components/layout/FooterScreen.vue";
import AiAssistantWidget from "@/components/common/AiAssistantWidget.vue";
import { hasExactRole, ROLES } from "@/utils/permissions";

export default {
  name: "AppLayoutSidebar",
  components: { SidebarMenu, HeaderTopBar, Footer, AiAssistantWidget },

  data() {
    return {
      userFullName: this.getCookie("ufn") || "Utilisateur",
      desktopCollapsed: false, // desktop preference
      windowWidth: window.innerWidth, // reactive window width
    };
  },

  computed: {
    // Mobile detection
    isMobile() {
      return this.windowWidth < 768;
    },

    // Collapsed state
    collapsed() {
      return this.isMobile ? true : this.desktopCollapsed;
    },
    
    // Dynamic content style
    contentStyle() {
      if (this.isMobile) {
        return { marginLeft: "0", width: "100%" };
      }
      const collapsedWidth = "67px";
      const expandedWidth = "260px";
      const width = this.collapsed ? collapsedWidth : expandedWidth;
      return { marginLeft: width, width: `calc(100% - ${width})` };
    },

    showAiAssistant() {
      return !this.isAccountantOnlyUser();
    },

    showHeaderTopBar() {
      return !this.isMobile || this.isAdminUser();
    },
  },

  mounted() {
    window.addEventListener("resize", this.handleResize);
  },

  beforeUnmount() {
    window.removeEventListener("resize", this.handleResize);
  },

  methods: {
    getCookie(name) {
      const cookies = document.cookie.split("; ");
      for (let cookie of cookies) {
        const [cookieName, cookieValue] = cookie.split("=");
        if (cookieName === name) return decodeURIComponent(cookieValue);
      }
      return null;
    },

    handleResize() {
      this.windowWidth = window.innerWidth;
    },

    updateCollapsed(value) {
      this.desktopCollapsed = value;
    },

    isAdminUser() {
      return hasExactRole(ROLES.ADMIN);
    },

    isAccountantOnlyUser() {
      return (
        hasExactRole(ROLES.ACCOUNTANT) &&
        !hasExactRole(ROLES.SUPPLIER) &&
        !hasExactRole(ROLES.ADMIN)
      );
    },
  },
};
</script>

<style scoped>
.layout-wrapper {
  display: flex;
  min-height: 100vh;
  width: 100%;
  position: relative;
}

.layout-content {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  transition: margin-left 0.3s ease, width 0.3s ease;
  background: #f4f6fb;
}

.content {
  flex: 1;
}

@media (max-width: 767px) {
  .layout-content {
    padding-bottom: calc(108px + env(safe-area-inset-bottom));
  }
}
</style>
